<template>
  <div class="hall-overview" @click="hideHallOverview" v-if="hallOverview">
    <v-card>
      <v-card-text>
        <img :src="hallOverviewImage"/>
      </v-card-text>
    </v-card>
  </div>
  <div v-else>
    <div>
      <div class="col-12 mb-4" v-if="bookingStep == 1">
        <v-card>
          <v-card-text>
            <div v-if="stagePosition === 'top'" class="stage">
              <div class="text-center d-xs-flex d-md-none justify-content-center align-items-center">
                <v-icon>keyboard_arrow_left</v-icon>
                Плъзнете за останалите места
                <v-icon>keyboard_arrow_right</v-icon>
              </div>

              <template v-if="event.schema_settings && event.schema_settings.hex == true">
                <div class="stage-index">L</div>
                <div class="stage-index">R</div>
              </template>

              <div class="label">
                {{ stageLabelText }}
              </div>
            </div>

            <div ref="venueMapWrapper" :style="getWrapperStyle()" class="venue-map-wrapper">
              <div :class="seatStyle" class="venue-map">
                <div v-if="event.status == 2 || event.status == 3" class="overlay sold-out">SOLD OUT</div>

                <pan-zoom ref="pz" :options="panZoomOptions" @init="onInit">
                  <div
                      ref="hallWrapper"
                      :class="{'circular-seats': (event.schema_settings && event.schema_settings.circular_seats === true)}"
                      class="hall-zoom-wrapper"
                      style="width: 100%; display: block"
                  >
                    <div class="sizer"></div>
                    <div
                        v-for="(row, rowIndex) in schema" :class="{'ga-row': (row.length === 1 && row[0].type === 'GA')}"
                        class="row hall-row"
                    >
                      <template v-if="row.length === 1 && row[0].type === 'GA'">
                        <ga-section
                            :row="row"
                            :selected-ga-seats="selectedGaSeats"
                            class="ga-section-wrapper"
                            @set-selection-to="(value) => selectGaTicket(row[0].id, value)"
                        />
                      </template>
                      <div v-else-if="row.length === 1 && row[0].type === 'LABEL'" class="label-row">
                        <div v-html="row[0].html"/>
                      </div>
                      <template v-else>
                        <div
v-show="event.schema_settings && event.schema_settings.show_numbers === true"
                             class="row-number">
                          {{ skipRow(row, rowIndex) }}
                        </div>

                        <div
                            :class="'seatsWrapper row ' + seatsDirection"
                            :style="'flex: 1'"
                        >
                          <template v-for="(seat, seatIndex) in row">

                            <template
                                v-if="seat.disabled || seat.sold || seat.seatType == seatTypes.NO_SEAT || seat.empty">
                              <div
                                  :class="calculateClass(seat)" :style="'background-color:' + seat.color +'; color:' + seat.color + ' !important'"
                                  class="seat"
                              >
                                <span class="seat-number">{{ friendlySeatString(seat) }}</span>
                              </div>
                            </template>
                            <template v-else>
                              <v-tooltip top>
                                <template #activator="{ on }">
                                  <div
                                    class="seat" :class="calculateClass(seat)" v-on="on"
                                    @click="selectSeat(seat, rowIndex, seatIndex)"
                                    :style="'background-color:' + seat.color +'; color:' + seat.color + ' !important'"
                                  >
                                    <span class="seat-number">{{ friendlySeatString(seat) }}</span>
                                  </div>
                                </template>
                                <span>
                                {{ seat.indexFriendly }}<br>
                                {{ currencySign }}{{ seat.price * seat.generated_per_ticket }}
                              </span>
                              </v-tooltip>
                            </template>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </pan-zoom>

                <div v-if="zoomEnabled" style="display: flex; justify-content: space-between; background: white; position: relative; z-index: 1; padding-top: 10px;">
                  <v-btn @click="zoomOutSchema" icon><v-icon >mdi-magnify-minus</v-icon></v-btn>
                  <v-btn @click="zoomInSchema"  icon><v-icon >mdi-magnify-plus</v-icon></v-btn>
                </div>
              </div>
            </div>

            <div v-if="stagePosition === 'bottom'" class="stage">
              <div class="text-center d-xs-flex d-md-none justify-content-center align-items-center">
                <v-icon>keyboard_arrow_left</v-icon>
                Плъзнете за останалите места
                <v-icon>keyboard_arrow_right</v-icon>
              </div>

              <template v-if="event.schema_settings && event.schema_settings.hex == true">
                <div class="stage-index">L</div>
                <div class="stage-index">R</div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div v-if="event.status != 2 || event.status != 3" class="col-12 mb-4">
        <template v-if="bookingStep == 1">
          <v-card>
            <v-card-title>Избрани билети</v-card-title>
            <v-card-text>
              <div class="row ticket-details">
                <div class="col-12">
                  <b>Вашите детайли:</b>
                </div>
                <div class="col-12 col-sm-4">
                  <v-text-field v-model="client.name" label="Име и Фамилия" required></v-text-field>
                </div>
                <div class="col-12 col-sm-4">
                  <v-text-field v-model="client.email" label="Email" required></v-text-field>
                </div>
                <div class="col-12 col-sm-4">
                  <v-text-field v-model="client.phone" label="Телефон" required></v-text-field>
                </div>

                <div class="col-12 text-center align-self-center">
                  <v-alert
                    :value="true"
                    color="warning"
                    icon="priority_high"
                    outlined
                    class="alert-box"
                  >
                    За да предотвратите неоторизирано използване
                    на билетите, моля попълнете имената на хората, които ще присъстват на събитието. При нужда имената
                    могат да бъдат променени на място преди събитието.
                  </v-alert>
                </div>

                <template v-for="seat in selectedSeats">
                  <div class="col-12 col-sm-6">
                    <b>Място: {{ seat.indexFriendly }} &#8901; Цена: {{ currencySign }}{{ seat.price * seat.generated_per_ticket }}</b> <br>

                    <div class="row m-0">
                      <v-text-field v-model="seat.name" label="Име и Фамилия" required></v-text-field>
                      <v-btn text icon color="pink" @click="selectSeat(seat, null, null)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </template>
                <template v-for="(groups, index) in selectedGaSeats">
                  <div class="col-12 col-sm-6" v-for="(seat, key) in groups">
                    <b>#Свободен достъп | Цена: {{ seat.price * seat.generated_per_ticket }}{{ currencySign }}</b> <br>
                    <v-text-field v-model="seat.name" label="Име и Фамилия"></v-text-field>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col">
                  <tos-checkbox
                    :is-valid="isGdprValid"
                    @update-gdpr="(v) => (gdpr = v)"
                  ></tos-checkbox>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-6 align-self-center"><h5 class="price-total">Общо:
                  {{ currencySign }}{{ seatsTotal.toFixed(2) }}</h5></div>
                <div class="col-6 justify-content-end text-right">
                  <v-btn class="primary" @click="reserveSeats()" :disabled="payBtnDisabled">Плащане</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </template>

        <template v-if="bookingStep == 2">
          <Payment
            :selected-tickets="selectedTicketItems" :event="event" :amount="seatsTotal" :secret="secret"
            :enable-borika="true"
          ></Payment>
        </template>


      </div>
      <div v-else class="col-12 mb-4">
        <EmailSubscription :event="event"></EmailSubscription>
      </div>
    </div>
  </div>
</template>
<script>
import goTo from 'vuetify/lib/services/goto'
import Payment from './Payment'
import EmailSubscription from './EmailSubscription'
import GaSection from "./MixedEvent/GaSection"
import TosCheckbox from "./components/TosCheckbox"

// document.body.addEventListener('touchmove', (event) => {
//   event.preventDefault()
// })

export default {
  components: {
    Payment,
    EmailSubscription,
    GaSection,
    TosCheckbox,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hallOverview: false,
      hallOverviewImage: null,
      payBtnDisabled: false,
      gdpr: false,
      isGdprValid: true,
      bookingStep: 1,
      seatTypes: {
        NO_SEAT: 0,
        REGULAR_SEAT: 1,
      },
      selectedSeats: [],
      selectedGaSeats: {},
      client: {
        name: '',
        email: '',
        phone: '',
      },
      error: false,
      secret: '',
    }
  },
  computed: {
    panZoomOptions() {
      return {
        // minZoom: 0.1,
        maxZoom: 1.5,
        onTouch(e) {
          // `e` - is current touch event.
          if (!e.target.classList.contains('seat-number') && !e.target.classList.contains('ga-section-wrapper')) {
            // console.log('prevent')
            return false // tells the library to not preventDefault.
          }

          // console.log('not prevent')
        },
      }
    },
    zoomEnabled() {
      if (this.event.schema_settings && this.event.schema_settings.zoomable) {
        return this.event.schema_settings.zoomable
      }

      return false
    },
    schema() {
      if (!this.event.decoded_settings.through_place) {
        return this.event.schema
      }
      this.event.schema.forEach((row, index) => {
        row.forEach((seat, seatIndex) => {
          this.event.schema[index][seatIndex].empty = false
          if (!(index % 2)) {
            if (seatIndex % 2) {
              this.event.schema[index][seatIndex].empty = true
            }
          } else if (!(seatIndex % 2)) {
            this.event.schema[index][seatIndex].empty = true
          }
        })
      })

      return this.event.schema
    },
    id() {
      return this.event.id
    },
    seatsDirection() {
      if (this.event.seats_direction) {
        return 'seat-direction-reverse'
      }

      return 'seat-direction-normal'
    },
    seatStyle() {
      if (this.event.schema_settings && this.event.schema_settings.hex == true) {
        return "hex-seats"
      }

      return "square-seats"
    },
    seatsTotal() {
      let sum = 0
      this.selectedSeats.forEach((item) => {
        sum += parseFloat(item.price) * item.generated_per_ticket
      })

      Object.entries(this.selectedGaSeats).forEach(([key, item]) => {
        item.forEach((seat) => {
          sum += parseFloat(seat.price) * item.generated_per_ticket
        })
      })

      return sum
    },
    selectedTickets() {
      return this.selectedSeats.length
    },
    selectedTicketItems() {
      const items = [...this.selectedSeats]

      Object.entries(this.selectedGaSeats).forEach(([key, item]) => {
        item.forEach((seat) => {
          items.push(seat)
        })
      })

      return items
    },
    wrapperWidth() {
      let max = 0
      this.event.schema.forEach((item) => {
        if (item.length > max) {
          max = item.length
        }
      })

      return max * 20
    },
    currencySign() {
      if (this.event.decoded_settings.currency === 'BGN') {
        return 'BGN'
      }
      if (this.event.decoded_settings.currency === 'GBP') {
        return '£'
      }
      if (this.event.decoded_settings.currency === 'USD') {
        return '$'
      }
      return '€'

    },
    stagePosition() {
      if (this.event.schema_settings && this.event.schema_settings.stage_position) {
        return this.event.schema_settings.stage_position
      }

      return 'top'
    },
    stageLabelText() {
      if (this.event.id == 251 || this.event.id == 230) {
        return 'Сцена/Екран';
      }

      return 'Stage';
    },
  },
  locals: {
    rowSkipCorrectionIndex: 0,
  },
  methods: {
    hideHallOverview() {
      this.hallOverview = false
    },
    friendlySeatString(seat) {
      if (seat.indexFriendly.split(':').length == 2) {
        return seat.indexFriendly.split(':')[1]
      }
      if (seat.indexFriendly.split(':').length == 3) {
        return seat.indexFriendly.split(':')[2]
        // return seat.indexFriendly.split(':')[0] + ":" + seat.indexFriendly.split(':')[2];
      }
      return seat.indexFriendly

    },
    selectSeat(seat, rowIndex, seatIndex) {

      if (seat.sold || seat.disabled || seat.blocked || seat.empty) {
        return
      }

      if (this.selectedTickets >= 10 && (seat.selected == false || typeof seat.selected === 'undefined')) {
        return
      }

      this.$set(seat, 'selected', !seat.selected)

      if (seat.selected) {
        this.selectedSeats.push(seat)
      } else {
        const index = _.findIndex(this.selectedSeats, {'index': seat.index})
        this.selectedSeats.splice(index, 1)
      }
    },
    calculateClass(seat) {
      let className = ''

      if (seat.seatType == this.seatTypes.NO_SEAT) {
        className += ' invisible'
      }

      if (seat.disabled) {
        className += ' disabled'
      }

      if (seat.sold || seat.blocked) {
        className += ' disabled'
      }

      if (seat.empty) {
        className += ' empty'
      }

      if (seat.selected) {
        className += ' selected'
      }

      return className
    },
    reserveSeats() {
      let error = false
      this.payBtnDisabled = true

      if (!this.gdpr) {
        this.isGdprValid = false
        this.payBtnDisabled = false
        return
      }

      if (this.client.name.length < 3) {
        error = {
          'error': true,
          'reason': "Полето Име е задължително!",
        }
      }

      if (this.client.email.length < 3) {
        error = {
          'error': true,
          'reason': "Полето Email е задължително!",
        }
      }

      this.selectedSeats.forEach((item) => {
        if (typeof item.name === 'undefined' || item.name.length < 3) {
          error = {
            'error': true,
            'reason': "Моля попълнете всички полета!",
          }
        }
      })

      Object.entries(this.selectedGaSeats).forEach(([key, item]) => {
        item.forEach((seat) => {
          if (typeof seat.name === 'undefined' || seat.name.length < 3) {
            error = {
              'error': true,
              'reason': "Моля попълнете всички полета!",
            }
          }
        })
      })

      if (error) {
        this.error = error
        alert(error.reason)
        this.payBtnDisabled = false
        return
      }

      const data = {
        client: this.client,
        seats: this.selectedSeats,
        gaSeats: this.selectedGaSeats,
      }

      axios.post(`/event/${this.id}/ticket`, data).then((response) => {
        this.secret = response.data.secret
        this.bookingStep = 2
      }).catch((error) => {
        alert(error.response.data.message)
      }).finally(() => {
        this.payBtnDisabled = false
      })
    },
    skipRow(row, index) {
      let skip = true

      _.each(row, (item) => {
        if (item.seatType != this.seatTypes.NO_SEAT) {
          skip = false
          return false
        }
      })

      if (skip) {
        this.$options.locals.rowSkipCorrectionIndex++
      }

      if (this.$options.locals.rowSkipCorrectionIndex > this.event.schema.length ||
        (index + 1 - this.$options.locals.rowSkipCorrectionIndex) < 1) {
        this.$options.locals.rowSkipCorrectionIndex = 0
      }

      let number = index + 1 - this.$options.locals.rowSkipCorrectionIndex

      if (skip) {
        number = ''
      }

      return number
    },
    selectGaTicket(rowID, value) {
      if (!this.selectedGaSeats.hasOwnProperty(rowID)) {
        this.$set(this.selectedGaSeats, rowID, [])
      } else {
        this.selectedGaSeats[rowID] = []
      }

      for (let i = 1; i <= value; i++) {
        const GaZone = this.schema.filter((item) => item.length === 1 && item[0].type === "GA" && item[0].id === rowID)[0][0]

        if (GaZone.totalTickets < (GaZone.ticketsSold + this.selectedGaSeats[rowID].length + 1)) {
          alert('Достигнахте лимита на билетите.')
          return
        }

        this.selectedGaSeats[rowID].push({
          rowID,
          type: 'ga',
          name: '',
          price: GaZone.price,
          quantity: 1,
        })
      }

      goTo('.ticket-details')
    },
    onInit() {

      if (!this.zoomEnabled) {
        this.$refs.pz.$panZoomInstance.pause()
        return
      }

      this.centerSchema()
    },
    centerSchema() {
      const screenSize = {
        w: this.$refs.venueMapWrapper.offsetWidth,
        h: this.$refs.venueMapWrapper.clientHeight,
      }
      const elemWid = this.$refs.hallWrapper.scrollWidth
      const elemHei = this.$refs.hallWrapper.scrollHeight

      const initalZoom = (screenSize.w / elemWid < screenSize.h / elemHei) ? screenSize.w / elemWid  : screenSize.h / elemHei

      this.$refs.pz.$panZoomInstance.zoomAbs(0, 0, initalZoom)
      this.$refs.pz.$panZoomInstance.moveTo((screenSize.w - elemWid * initalZoom) / 2, (screenSize.h - elemHei * initalZoom) / 2)

      setTimeout(() => {
        const {height} = document.getElementsByClassName('hall-zoom-wrapper')[0].getBoundingClientRect()
        this.$refs.pz.$el.style.height = `${height + 100}px`
      }, 500)
    },
    zoomInSchema() {
      const screenSize = {
        w: this.$refs.venueMapWrapper.offsetWidth,
        h: this.$refs.venueMapWrapper.clientHeight,
      }
      const elemWid = this.$refs.hallWrapper.scrollWidth
      const elemHei = this.$refs.hallWrapper.scrollHeight
      this.$refs.pz.$panZoomInstance.zoomTo(0,0,2)
      this.$refs.pz.$panZoomInstance.moveTo((screenSize.w - elemWid ) / 2, (screenSize.h - elemHei) / 2)
    },
    zoomOutSchema() {
      const screenSize = {
        w: this.$refs.venueMapWrapper.offsetWidth,
        h: this.$refs.venueMapWrapper.clientHeight,
      }
      const elemWid = this.$refs.hallWrapper.scrollWidth
      const elemHei = this.$refs.hallWrapper.scrollHeight
      this.$refs.pz.$panZoomInstance.zoomTo(0,0,0.5)
      this.$refs.pz.$panZoomInstance.moveTo((screenSize.w - elemWid * 0.5) / 2, (screenSize.h - elemHei * 0.5) / 2)
    },
    getWrapperStyle() {
      if (this.zoomEnabled) {
        return {
          overflow: 'hidden',
        }
      }

      return {
        overflow: 'scroll',
      }
    },
  },
  created() {
    if (this.event.decoded_settings.hall_overview) {
      this.hallOverview = this.event.decoded_settings.hall_overview
      this.hallOverviewImage = this.event.hall_overview_image

      if (!this.event.decoded_settings.hall_overview_visible_mobile && window.innerWidth <= 480) {
        this.hideHallOverview()
      }
      if (!this.event.decoded_settings.hall_overview_visible_desktop && window.innerWidth > 480) {
        this.hideHallOverview()
      }
    } else {
      this.hallOverview = false
    }
  },
}
</script>
<style scoped lang="scss">
.seatsWrapper {
  justify-content: center;
}

.seat-direction-normal {
  flex-direction: row;
}

.seat-direction-reverse {
  flex-direction: row-reverse;
}

.stage-index {
  position: absolute;
  font-size: 20px;
  font-weight: bold;

  &:first-of-type {
    left: 10px;
  }

  &:last-of-type {
    right: 10px;
  }
}

.hall-overview {
  cursor: pointer;
  text-align: center;

  img {
    max-width: 100%;
  }
}

.label-row {
  //padding-left: 40px;
  width: 100%;
}

.venue-map-wrapper {
  width: 100%;
  overflow: scroll;
}

.venue-map {
  //width: fit-content;
  //width: -moz-fit-content;
  //
  width: 100%;
}

.venue-map > .row {
  width: fit-content;
  width: -moz-fit-content;

  @media (max-width: 578px) {
    &.ga-row {
      width: fit-content;

      .ar-general-admission {
        margin: 0px;
      }
    }
  }
}

.venue-map {
  overflow: visible;
  margin: 0 auto;

  .hall-row {
    width: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    margin-top: 0;
  }

  .ga-row {
    justify-content: center;
  }
}

.venue-map .row .seat.empty {
  border-color: orange !important;
  opacity: 0.3;
  background: #ccc !important;
  cursor: default;
}

.venue-map .row .seat.empty span {
  color: orange !important;
}

.alert-box {
  color: white !important;
}

.venue-map {
  .row {

    .seat.rounded {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      flex: none;
    }

    .row-number {
      //flex: 0;
      //position: absolute;
      margin: 0;
    }

  }
}

.circular-seats .seat {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  padding: 0;
  flex: none;
  margin: 1px;

  span {
    display: none;
  }
}

.stage::after {
  content: '';
}

.stage .label {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  color: black;
  //text-shadow: 0 0 2px black;
}
</style>
